import { createAsyncThunk } from '@reduxjs/toolkit';
import loggerGenerator from '@travel/logger';

import paths from 'core/universalRouter/paths';

import { pushLocation } from 'store/__router/actions';

import { apiPath } from 'constants/api';

import type { ReviewListResponse, ReviewRequestBody } from './types';

import type { ApiClient } from '@travel/api-client';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const fetchReviewList = createAsyncThunk<
  ReviewListResponse,
  ReviewRequestBody,
  { extra: { apiClient: ApiClient } }
>('reviewList/fetchReviewList', async (payload, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  const { apiClient } = thunkAPI.extra;

  try {
    const data = await apiClient.post(apiPath.reviewList.pathname, {
      values: payload,
    });

    return data;
  } catch (error) {
    logger.error('Fetch Review List Failed', error);
    noticeError('Fetch Review List Error Failed', error);

    return rejectWithValue(error);
  }
});

export const fetchSelectedReviewList = createAsyncThunk<
  ReviewListResponse,
  ReviewRequestBody,
  { extra: { apiClient: ApiClient } }
>('reviewList/fetchSelectedReviewList', async (payload, thunkAPI) => {
  const { dispatch, rejectWithValue } = thunkAPI;
  const { apiClient } = thunkAPI.extra;
  const providerId = payload.providerId;

  try {
    const data = await apiClient.post(apiPath.reviewList.pathname, {
      values: payload,
    });

    if (data.contents.length === 0 && providerId) {
      dispatch(pushLocation(paths.providerReview.pathResolver(providerId)));
    }

    return data;
  } catch (error) {
    logger.error('Fetch Selected Review List Failed', error);
    noticeError('Fetch Selected Review List Error Failed', error);

    return rejectWithValue(error);
  }
});
